import { SimpleGrid } from '~/design_system'
import { useHomeConfigQuery } from '~/api/home'
import { useMsg } from '~/common/localizationUtils'
import { defaultFilters as headCountFilters, HeadCountByVendor } from '~/dashboards/Headcount'
import { SpendByMonth } from '~/dashboards/Spend'
import { defaultSpendFilters } from '~/dashboards/Summary'

export const Dashboards = props => {
  const msg = useMsg()
  const { data, isLoading } = useHomeConfigQuery()
  const { enabled, can_access_dashboard: canAccessDashboard } = { ...data?.dashboards }
  return (
    !isLoading &&
    enabled &&
    canAccessDashboard && (
      <SimpleGrid columns={{ base: 1, xl: 2 }} spacing={6} {...props}>
        <SpendByMonth
          filters={defaultSpendFilters}
          subTitle={msg('dashboards.chart.spend_by_month.sub_title')}
          flex="1"
        />
        <HeadCountByVendor filters={headCountFilters} flex="1" />
      </SimpleGrid>
    )
  )
}
